const AttributeSelection = (($) => {

    $(document).ready(function(){

        $('.product-attribute').find('input[type=radio]').on('change', function(){
            $(this).parents('.product-attribute').find('.product-attribute__value').removeClass('active');
            $(this).parents('.product-attribute__value').addClass('active')
        })
    });
})(jQuery);

// export default AttributeSelection
